<template>
    <span class="copyright">
        © Copyright 2021 PagerDuty, Inc. All rights reserved.
    </span>
</template>

<script>
export default {
    
}
</script>

<style scoped lang="scss">
.copyright {
    color: var(--font-color);
}
</style>